/** Spanish. */
export const es = {
    common: {
        save: 'Guardar',
        saving: 'Guardando…',
        saved: 'Guardado',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        edit: 'Editar',
        close: 'Cerrar',
        back: 'Volver',
        retry: 'Reintentar',
        loading: 'Cargando…',
        search: 'Buscar',
        signOut: 'Cerrar sesión',
        store: 'Tienda',
        status: 'Estado',
        email: 'Correo electrónico',
        password: 'Contraseña',
        firstName: 'Nombre',
        lastName: 'Apellidos',
        phone: 'Teléfono',
        total: 'Total',
        subtotal: 'Subtotal',
        quantity: 'Cantidad',
        price: 'Precio',
        stock: 'Existencias',
        language: 'Idioma',
        never: 'Nunca',
        none: '—',
    },
    nav: {
        products: 'Productos',
        orders: 'Pedidos',
        customers: 'Clientes',
        settings: 'Configuración',
        website: 'Sitio web',
        apps: 'Aplicaciones',
        themes: 'Temas',
        installs: 'Instalaciones',
    },
    auth: {
        signInTitle: 'Iniciar sesión',
        signInSubtitle: 'Accede al panel de tu tienda.',
        partnerSubtitle: 'Crea aplicaciones y temas para comerciantes.',
        signIn: 'Iniciar sesión',
        signingIn: 'Iniciando sesión…',
        createStore: 'Crea tu tienda',
        creatingStore: 'Creando tu tienda…',
        haveAccount: '¿Ya tienes una tienda? Inicia sesión',
        needAccount: '¿Aún no tienes tienda? Crea una',
        storeName: 'Nombre de la tienda',
        storeAddress: 'Dirección de la tienda',
        passwordHint: 'Mínimo 12 caracteres',
        slugChecking: 'Comprobando disponibilidad…',
        slugTaken: '{{slug}} no está disponible. Te sugerimos {{suggestion}}.',
        slugFree: '{{slug}} está disponible.',
    },
    products: {
        title: 'Productos',
        searchPlaceholder: 'Buscar por título, identificador o proveedor…',
        newProduct: 'Nuevo producto',
        columnProduct: 'Producto',
        columnPrice: 'Precio',
        columnStock: 'Existencias',
        columnVariants: 'Variantes',
        statusActive: 'Activo',
        statusDraft: 'Borrador',
        statusArchived: 'Archivado',
        empty: 'Aún no hay productos. Añade el primero para empezar a vender.',
        variantCount: { one: '{{count}} variante', other: '{{count}} variantes' },
        stockLevel: {
            zero: 'Agotado',
            one: '{{count}} en existencias',
            other: '{{count}} en existencias',
        },
        variantTitle: 'Nombre de la variante',
        sku: 'SKU',
        couldNotLoadVariants: 'No se pudieron cargar las variantes.',
    },
    orders: {
        title: 'Pedidos',
        searchPlaceholder: 'Buscar por número de pedido o correo…',
        columnOrder: 'Pedido',
        columnCustomer: 'Cliente',
        columnPayment: 'Pago',
        columnFulfilment: 'Preparación',
        columnPlaced: 'Realizado',
        shipTo: 'Enviar a',
        item: 'Artículo',
        qty: 'Cant.',
        unit: 'Unidad',
        empty: 'Aún no hay pedidos.',
        itemCount: { one: '{{count}} artículo', other: '{{count}} artículos' },
        financial: {
            PENDING: 'Pago pendiente',
            AUTHORIZED: 'Autorizado',
            PAID: 'Pagado',
            PARTIALLY_REFUNDED: 'Reembolsado parcialmente',
            REFUNDED: 'Reembolsado',
            VOIDED: 'Anulado',
        },
        fulfilment: {
            UNFULFILLED: 'Sin preparar',
            PARTIAL: 'Preparado parcialmente',
            FULFILLED: 'Preparado',
            RESTOCKED: 'Devuelto al inventario',
        },
    },
    customers: {
        title: 'Clientes',
        searchPlaceholder: 'Buscar por nombre o correo…',
        newCustomer: 'Nuevo cliente',
        columnCustomer: 'Cliente',
        columnOrders: 'Pedidos',
        columnMarketing: 'Marketing',
        lifetimeSpend: 'Gasto total',
        acceptsMarketing: 'Acepta marketing',
        empty: 'Aún no hay clientes.',
        orderCount: { zero: 'Sin pedidos', one: '{{count}} pedido', other: '{{count}} pedidos' },
    },
    settings: {
        title: 'Configuración de la tienda',
        storefront: 'Tu tienda online',
        storefrontHint: 'Ya está publicada. En desarrollo local el subdominio no está en el DNS: el servidor de desarrollo fija la cabecera Host en su lugar.',
        details: 'Datos',
        customDomain: 'Dominio propio',
        customDomainHint: 'Apunta un CNAME a Upweo y escribe solo el nombre de host. Déjalo vacío para usar la dirección de arriba.',
        addressHint: '{{host}} — cambiarlo romperá los enlaces existentes',
        currency: 'Moneda',
        country: 'País',
        plan: 'Plan',
        currencyLocked: 'La moneda no se puede cambiar cuando ya existen pedidos: los totales históricos dejarían de tener sentido.',
        languages: 'Idiomas',
        defaultLanguage: 'Idioma predeterminado',
        defaultLanguageHint: 'Lo que ve un comprador cuando su navegador pide un idioma que no ofreces.',
        storefrontLanguages: 'Idiomas de la tienda',
        storefrontLanguagesHint: 'Los compradores pueden cambiar entre los idiomas que marques. Desmarca uno para ocultarlo en lugar de mostrar una tienda a medio traducir.',
        saveFailed: 'No se pudo guardar la configuración',
    },
    payments: {
        title: 'Pagos',
        testMode: 'Modo de prueba',
        live: 'Activo',
        needsWebhook: 'Falta el webhook',
        notConnected: 'Sin conectar',
        account: 'Cuenta',
        secretKey: 'Clave secreta',
        publishableKey: 'Clave publicable',
        webhookSecret: 'Clave de firma del webhook',
        verified: 'Verificado',
        webhookEndpoint: 'Endpoint del webhook',
        connect: 'Conectar Stripe',
        update: 'Actualizar claves',
        disconnect: 'Desconectar',
        verifying: 'Verificando…',
        savedAndVerified: 'Guardado y verificado',
        copy: 'Copiar',
        copied: 'Copiado',
        disabledNotConnected: 'El pago está desactivado hasta que conectes una cuenta de Stripe. Los compradores pueden navegar y llenar el carrito, pero no pagar.',
        disabledNoWebhook: 'Tus claves están guardadas, pero el pago sigue desactivado hasta que añadas la clave de firma del webhook. Sin ella podemos iniciar un pago pero nunca sabremos que se completó: los pedidos quedarían sin pagar mientras el dinero llega a Stripe.',
        secretKeyHintNew: 'Empieza por sk_ o rk_. Se guarda cifrada y no se vuelve a mostrar.',
        secretKeyHintExisting: 'Déjalo vacío para conservar la clave ya guardada.',
        publishableKeyHint: 'Empieza por pk_. Se envía al navegador del comprador, así que esta es pública por diseño.',
        webhookSecretHint: 'Empieza por whsec_. Stripe la muestra una sola vez al crear el endpoint de arriba.',
        saveFailed: 'No se pudo guardar la configuración de pagos',
        disconnectFailed: 'No se pudo desconectar',
    },
    shop: {
        shopAll: 'Ver todo',
        searchPlaceholder: 'Buscar…',
        soldOut: 'Agotado',
        addToCart: 'Añadir al carrito',
        adding: 'Añadiendo…',
        options: 'Opciones',
        productNotFound: 'Producto no encontrado',
        continueShopping: 'Seguir comprando',
        poweredBy: '{{store}} — con tecnología de Upweo',
        cart: 'Carrito',
        cartEmpty: 'Tu carrito está vacío',
        decreaseQuantity: 'Reducir cantidad',
        increaseQuantity: 'Aumentar cantidad',
        remove: 'Quitar',
        taxNotice: 'Los impuestos y el envío aún no están calculados.',
        checkout: 'Finalizar compra',
        contact: 'Contacto',
        shippingAddress: 'Dirección de envío',
        address: 'Dirección',
        city: 'Ciudad',
        postcode: 'Código postal',
        country: 'País',
        orderSummary: 'Resumen del pedido',
        editCart: 'Editar carrito',
        continueToPayment: 'Continuar al pago · {{total}}',
        preparingPayment: 'Preparando el pago…',
        payment: 'Pago',
        pay: 'Pagar {{total}}',
        paying: 'Pagando…',
        paymentSecurity: 'Los pagos los procesa Stripe. Los datos de tu tarjeta nunca se envían a esta tienda.',
        paymentFailed: 'El pago no se completó. Prueba con otra tarjeta.',
        thankYou: 'Gracias',
        orderPaid: 'El pedido {{order}} por {{total}} está pagado.',
        confirmationSent: 'Enviaremos una confirmación a {{email}}.',
        cartCount: { zero: 'Carrito', one: 'Carrito ({{count}})', other: 'Carrito ({{count}})' },
    },
    partner: {
        title: 'Upweo Partners',
        apps: 'Aplicaciones',
        newApp: 'Nueva aplicación',
        clientId: 'ID de cliente',
        clientSecret: 'Secreto de cliente',
        scopes: 'Permisos',
        requestedScopes: 'Permisos solicitados',
        installs: 'Instalaciones',
        grantedScopes: 'Permisos concedidos',
        installed: 'Instalada',
        themes: 'Temas',
        noThemes: 'Aún no hay temas.',
        noApps: 'Aún no hay aplicaciones.',
        activePartnerAccount: 'Cuenta de partner activa',
        installCount: {
            zero: 'Sin instalaciones',
            one: '{{count}} instalación',
            other: '{{count}} instalaciones',
        },
    },
    website: {
        subtitle: 'El sitio público en upweo.com',
        copy: 'Textos de marketing',
        copyHint: 'Deja un campo vacío para usar el texto que trae Upweo. Lo que aparece en gris es el texto actual para este idioma.',
        clearHint: 'Vaciar un campo restaura el texto original.',
        pricing: 'Planes de precios',
        pricingHint: 'Los precios se muestran con el formato numérico de cada visitante. Solo se traduce el texto: la cifra es la misma en todas partes.',
        published: 'Publicado',
        hidden: 'Oculto',
        publish: 'Publicar',
        hide: 'Ocultar',
        popular: 'El más elegido',
    },
    site: {
        nav: {
            features: 'Funciones',
            pricing: 'Precios',
            partners: 'Partners',
            signIn: 'Iniciar sesión',
            startFree: 'Empieza gratis',
        },
        hero: {
            title: 'Todo lo que necesitas para vender online',
            subtitle: 'Upweo te da una tienda, un proceso de pago y las herramientas para gestionar el negocio que hay detrás — en tu idioma, en tu moneda y en tu propio dominio.',
            ctaPrimary: 'Crea tu tienda',
            ctaSecondary: 'Ver precios',
            note: 'No hace falta tarjeta para empezar.',
        },
        features: {
            heading: 'Hecho para tiendas reales',
            subheading: 'Las partes de un negocio online que son tediosas de construir, ya resueltas.',
            f1Title: 'Tu propia tienda online',
            f1Body: 'Cada tienda recibe su dirección en cuanto te registras, y puede pasar a tu propio dominio cuando quieras.',
            f2Title: 'Productos y existencias',
            f2Body: 'Variantes con su propio precio y SKU, stock por ubicación e inventario reservado en el momento del pedido.',
            f3Title: 'Pagos de verdad',
            f3Body: 'Conecta tu propia cuenta de Stripe. El dinero de tus clientes va directamente a ti: nunca pasa por nosotros.',
            f4Title: 'Habla el idioma de tus clientes',
            f4Body: 'Seis idiomas, soporte de derecha a izquierda y precios con el formato de cada país. Los recibos llegan en el idioma que leía el comprador.',
            f5Title: 'Pedidos y clientes',
            f5Body: 'Cada pedido queda congelado en el momento de la compra, así tu historial sigue siendo exacto por mucho que cambie el catálogo.',
            f6Title: 'Aplicaciones y temas',
            f6Body: 'Un ecosistema de partners con OAuth, permisos acotados y webhooks, para ampliar tu tienda sin tocar tus datos.',
        },
        pricing: {
            heading: 'Precios sencillos',
            subheading: 'Empieza gratis. Sube de plan cuando suban los pedidos.',
            perMonth: '/mes',
            cta: 'Empezar',
            popular: 'El más elegido',
            placeholderNotice: 'Estas cifras son provisionales mientras Upweo está en beta. Hoy no se cobra nada.',
            empty: 'Estamos terminando de definir los precios. Mientras tanto, crear una tienda es gratis.',
        },
        partners: {
            heading: 'Crea para Upweo',
            subheading: 'Haz aplicaciones y temas para comerciantes, con un flujo OAuth real, permisos acotados y webhooks.',
            cta: 'Hazte partner',
            signIn: 'Acceso de partners',
            b1Title: 'APIs de verdad',
            b1Body: 'Una API GraphQL pública para la tienda y una API REST de administración, ambas versionadas.',
            b2Title: 'Acceso acotado',
            b2Body: 'Los comerciantes conceden exactamente los permisos que pide tu app, y pueden revocarlos.',
            b3Title: 'Webhooks',
            b3Body: 'Suscríbete a los eventos que te importan, con entrega firmada y reintentos.',
        },
        signup: {
            heading: 'Crea tu tienda',
            subheading: 'Se tarda un minuto. Todo esto se puede cambiar después.',
            submit: 'Crear mi tienda',
            submitting: 'Creando tu tienda…',
            haveAccount: '¿Ya vendes con Upweo? Inicia sesión',
            success: 'Tu tienda está lista. Te llevamos a tu panel…',
        },
        partnerSignup: {
            heading: 'Hazte partner',
            subheading: 'Cuéntanos quién eres. Revisamos a los nuevos partners antes de publicar sus apps.',
            accountName: 'Nombre de la empresa o del desarrollador',
            submit: 'Crear cuenta de partner',
            submitting: 'Creando tu cuenta…',
            success: 'Tu cuenta de partner está creada y pendiente de revisión. Te llevamos al portal…',
            haveAccount: '¿Ya eres partner? Inicia sesión',
            existingUserHint: '¿Ya tienes una cuenta de Upweo? Usa el mismo correo y contraseña y le añadiremos el acceso de partner.',
        },
        footer: {
            tagline: 'Comercio multi-tienda, construido en abierto.',
            product: 'Producto',
            forPartners: 'Para partners',
            rights: '© {{year}} Upweo',
        },
    },
    errors: {
        BAD_REQUEST: 'No se pudo interpretar la solicitud.',
        VALIDATION_FAILED: 'Revisa los campos marcados.',
        UNAUTHENTICATED: 'Vuelve a iniciar sesión.',
        FORBIDDEN: 'No tienes permiso para hacer eso.',
        TENANT_NOT_RESOLVED: 'No pudimos determinar de qué tienda se trata.',
        NOT_FOUND: 'No se encontró.',
        CONFLICT: 'Entra en conflicto con algo que ya existe.',
        RATE_LIMITED: 'Demasiados intentos. Espera un momento.',
        PAYMENT_FAILED: 'No se pudo completar el pago.',
        INTERNAL_ERROR: 'Algo salió mal por nuestra parte.',
        network: 'No se pudo conectar con el servidor. Comprueba tu conexión.',
    },
    email: {
        orderConfirmation: {
            subject: 'Pedido {{order}} confirmado',
            preheader: 'Hemos recibido tu pedido y tu pago.',
            heading: 'Gracias por tu pedido',
            greeting: 'Hola {{name}}:',
            intro: '{{store}} ha recibido tu pedido y tu pago se ha confirmado.',
            orderLabel: 'Pedido',
            datePlaced: 'Fecha',
            itemsHeading: 'Lo que has pedido',
            subtotal: 'Subtotal',
            shipping: 'Envío',
            tax: 'Impuestos',
            total: 'Total',
            shippingTo: 'Enviar a',
            nextSteps: 'Te escribiremos de nuevo cuando tu pedido salga.',
            footer: 'Este correo lo envía {{store}}.',
        },
        passwordReset: {
            subject: 'Restablece tu contraseña de Upweo',
            preheader: 'Un enlace para elegir una nueva contraseña.',
            heading: 'Restablece tu contraseña',
            intro: 'Alguien ha pedido restablecer la contraseña de {{email}}.',
            action: 'Elegir una nueva contraseña',
            expiry: 'Este enlace funciona una sola vez y caduca en {{minutes}} minutos.',
            ignore: 'Si no has sido tú, ignora este correo: tu contraseña no ha cambiado.',
            footer: 'Enviado por Upweo.',
        },
    },
};
//# sourceMappingURL=es.js.map